import React from "react";
import * as PropTypes from "prop-types";
import ItemChooser from "./ItemChooser";

const SectorChooser = props => {
  const items = [
    {
      value: "-1",
      label: "All sectors"
    },
    {
      value: "-2",
      label: "Sector mix"
    },
    {
      value: "6",
      label: "Public"
    },
    {
      value: "1",
      label: "Public (Donor)"
    },
    {
      value: "2",
      label: "Public (Government)"
    },
    {
      value: "3",
      label: "Private"
    },
    {
      value: "5",
      label: "Private (Subsidized)"
    },
    {
      value: "4",
      label: "Private (Non-Subsidized)"
    }
  ].filter(
    sector =>
      sector.value === "-1" || props.sectorIds.has(parseInt(sector.value, 10))
  );

  return (
    <ItemChooser
      id={props.id}
      label={props.label}
      items={items}
      value={props.selectedKey ? props.selectedKey.toString() : "-1"}
      onChange={value => {
        props.onChange(value === "-1" ? undefined : parseInt(value, 10));
      }}
    />
  );
};

SectorChooser.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  sectorIds: PropTypes.object,
  selectedKey: PropTypes.number,
  onChange: PropTypes.func.isRequired
};

SectorChooser.defaultProps = {
  label: "Select Sector",
  sectorIds: new Set()
};

export default SectorChooser;
